// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5b3e2165","455":"aba03114","977":"c5591fb2"}[chunkId] + ".chunk.js";
};